import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatReviews = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item._id}`,
        value: item._id,
        review_date: item.review_date && moment(item.review_date),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchReviews,
    create: createReview,
    update: updateReview,
    delete: deleteReviews
} = createCrudActions('REVIEW', "Opinión", formatReviews);
